import { initReactI18next } from 'react-i18next';

import i18next from 'i18next';

import { ScimMe } from '@talend/context';

import { LOCALES, EN_LOCALE, localeDefinition } from './locales';

export function getCurrentLocale(user: ScimMe): string {
	return LOCALES.find(locale => locale === user.preferredLanguage) || EN_LOCALE;
}

export function changeLocale(userLocale: string): void {
	i18next.changeLanguage(userLocale);
}

// ⚠️ This is bad but i can't find a better way to have this initialized at the very first
// when we land on the application before the code of the other module is interpreted
// If we have a i18n.t in a js file which is evaluated at "init" time, the value will not been set
// if the global i18n context is not initialized
i18next.use(initReactI18next).init({
	fallbackLng: EN_LOCALE,
	debug: false,
	lng: EN_LOCALE,
	interpolation: {
		escapeValue: false,
	},
});

Object.entries(localeDefinition).forEach(([language, locales]: [string, any]) => {
	Object.entries(locales).forEach(([namespace, translations]) => {
		i18next.addResources(language, namespace, translations);
	});
});
